import { selector } from 'recoil';

import { sessionState } from './atom';

export const isSignedIn = selector({
  key: 'Session/isSignedIn',
  get: ({ get }) => {
    const { signedIn, expiresAt } = get(sessionState);

    if (signedIn) {
      const now = new Date();

      if (!expiresAt || (expiresAt && expiresAt < now)) {
        return false;
      }

      return true;
    }

    return false;
  },
});
